import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginForm.css";

const LoginForm = ({ title, api, fields, navigation, navigateToSection }) => {
  const [formData, setFormData] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(api.endpoint, {
        method: api.method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const { token } = await response.json();
        sessionStorage.setItem("accessToken", token);
        // Handle Navigation
        if (navigation.onSuccess.startsWith("section-") && navigateToSection) {
            navigateToSection(navigation.onSuccess);
          } else {
            navigate(navigation.onSuccess);
          }

      } else {
        const errorData = await response.json();
        setErrorMessage(errorData.message || "Invalid credentials.");
        
      }
    } catch (error) {
      setErrorMessage("An error occurred. Please try again.");
    }
  };

  return (
    <div className="form-container">
      <form className="form" onSubmit={handleSubmit}>
        <h2 className="form-title">{title}</h2>
        {fields.map((field, index) => (
          <div key={index} className="form-group">
            <label htmlFor={field.name}>{field.label}</label>
            <input
              id={field.name}
              name={field.name}
              type={field.type}
              placeholder={field.placeholder}
              required={field.required}
              onChange={handleInputChange}
            />
          </div>
        ))}
        <button type="submit" className="submit-button">
          Login
        </button>
        {errorMessage && <div className="error-message">{errorMessage}</div>}
      </form>
    </div>
  );
};

export default LoginForm;
